import { useModals } from "web/hooks/modals"
import { v4 as uuid } from "uuid"
import Modal from "./Modal"

function RichTextModal({ value, respond }) {
  function handleSave(content) {
    respond(content)
  }

  function handleClear() {
    respond("CLEAR")
  }

  return (
    <Modal
      trixEditorId={uuid()}
      value={value}
      handleSave={handleSave}
      handleClear={handleClear}
    />
  )
}

export default function useRichTextModal({ label, value }) {
  const { showModal } = useModals()

  return async function () {
    return await showModal({
      title: label,
      fullScreen: false,
      heightPixels: 600,
      widthPixels: 800,
      component: ({ respond }) => (
        <RichTextModal value={value} respond={respond} />
      ),
    })
  }
}
